import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./Category.module.less";
import { CreationCard, CreationCardItem } from "./CreationCard";

export type CategoryProps = {
	name: string;
	items: readonly CreationCardItem[];
	trackingId: string;
	onOpen: (item: CreationCardItem) => void;
};

export const Category = (props: CategoryProps): ReactElement => {
	const {
		name,
		items,
		trackingId,
		onOpen
	} = props;

	return (
		<section
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<h3>{name}</h3>

			<ul className={styles.list}>
				{items.map((x): ReactElement => (
					<li
						{...setTrackingId(x.trackingId)}
						key={x.trackingId}
					>
						<CreationCard
							item={x}
							onClick={() => onOpen(x)}
						/>
					</li>
				))}
			</ul>
		</section>
	);
};
Category.displayName = "Category";
